import createAction from '../services/create-action';

export const CLEAR_FOLLOWERS = 'followers/CLEAR';
export const clearFollowers = createAction(CLEAR_FOLLOWERS);



// WEBPACK FOOTER //
// ./app/actions/clear-followers.js